/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */
import React from 'react';

export const HTMLPromoContainer = ({ promoID }) => (
  <div id="logout-promos-container">
    <div className="promo-message" id={promoID}>
      <div className="promo-content "></div>
    </div>
  </div>
);

export default HTMLPromoContainer;
